export default __webpack_public_path__ + "static/Metropolis-LightItalic-fe82a33ffda3750518e8852ee8bcd4d8.woff2";